/** @format */

export const KPI_WIDTH = 136;
export const SENSOR_COLUMN_WIDTH = 154;
export const SENSOR_COLUMN_SPREAD_WIDTH = 320;

export const MIN_PLAN_LETTERS = 3;
export const PLAN_LETTER_WIDTH = 8.1;

export const MIN_TITLE_LETTERS = 9;
export const TITLE_LETTER_WIDTH = 9;

export const SEARCH_DEBOUNCE_TIME = 300;
